'use client';

import { useCallback } from 'react';

import { forgotPassword } from '@eliadmin/core/src/api/customers/customers-api';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { env } from '@eliadmin/core/src/env';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';

/** Requests the e-mail with the reset link; the link opens the reset-password route (core contract). */
export function useSendResetLink() {
  const locale = useLocaleStore(s => s.currentLocale);

  return useCallback(
    (email: string) => {
      const returnUrl = new URL(ROUTES.RESET_PASSWORD(), env.NEXT_PUBLIC_APP_URL);
      return forgotPassword({ email, return_url: returnUrl.toString(), locale });
    },
    [locale],
  );
}
